import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

const useStyles = createUseStyles<string, { collapsed: boolean }, ITheme>(
  ({ breakpoints }: ITheme) => ({
    formatOptions: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      marginBottom: ({ collapsed }) => (collapsed ? '0px' : '32px'),

      [mediaQuery(breakpoints.laptop)]: {
        lineHeight: '28px',
        marginBottom: () => '12px',
      },
    },
    title: {
      fontSize: '24px',
      lineHeight: '40px',

      [mediaQuery(breakpoints.laptop)]: {
        lineHeight: '28px',
        fontSize: '20px',
      },
    },
    collapsibleContainer: {
      visibility: 'visible',
      [mediaQuery(breakpoints.laptop)]: {
        display: ({ collapsed }) => (collapsed ? 'none' : 'block'),
      },
    },
    collapse: {
      visibility: 'hidden',
      paddingTop: '10px',
      [mediaQuery(breakpoints.laptop)]: {
        visibility: 'visible',
      },
    },
  }),
  {
    name: 'preview-options',
  },
);

export default useStyles;
